<template>
    <div class="tower-tab-old" v-if="useold" :style="`background: ${color.value};` + tower.css">
        <p class="tower-bottom" :style="{ background: color.value }"></p>
        <p class="tower-top" style="margin-top:8px">
            <span class="title">{{ tower.title }}</span>
            <span class="hot-label" v-if="recommend">[今日推荐/{{ tower.hot }}]</span>
            <span class="hot-label" v-else>热度:{{ tower.hot }}</span>
            <small class="comment">
                <a :href="`/tower/?name=${tower.name}`" target="_blank" style="color:gray">[<span style="color:red;font-weight:bold">{{ tower.comment }}</span>条评论]</a>
            </small>
            <span class="tower-auths">
                <span class="tower-auth">{{ tower.author }}</span>
                <span v-if="tower.author2" class="tower-remaster">/{{ tower.author2 }}</span>
            </span>
            <span class="tower-tags">
                <span v-if="intest" style="color:red">测试期</span>
                <span v-for="tag of tags" :key="tag">{{ tag }}</span>
                <span>{{ tower.floors }}层</span>
            </span>
        </p>
        <p class="tower-info" @click="open" :style="{ bottom: infoBottom }" v-html="content"></p>
        <p class="tower-intro" ref="intro" v-html="tower.text"></p>
    </div>
    <div class="tower-tab" v-else :style="{ background: color.value }">
        <div class="tower-main">
            <div class="tower-content">
                <Cover :link="tower.link" :image="tower.image" :title="tower.title" />
            </div>
            <div class="tower-info">         
                <div class="hot-label">热度: {{ hot }}</div>
                <div>
                    <span class="tower-auth">{{ tower.author }}</span>
                    <span v-if="tower.author2" class="tower-remaster">/{{ tower.author2 }}</span>
                </div>
                <div>通关: {{ tower.win }}</div>
                <div>游玩: {{ tower.people }}</div>
            </div>
        </div>
        <div class="tower-bottom">
            <div class="tower-intro" v-html="tower.text || content"></div>
            <div class="tower-tags">
                <span v-if="intest" style="color:red">测试期</span>
                <span v-for="tag of tags" :key="tag">{{ tag }}</span>
                <span>{{ tower.floors }}层</span>
                <span class="tower-comment">
                    <a :href="`/tower/?name=${tower.name}`" target="_blank" style="color:gray">[<span style="color:red;font-weight:bold">{{ tower.comment }}</span>条评论]</a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Cover from '@/components/Cover.vue'

import { COLORS } from '../constant';
export default {
    props: [ 'tower', 'useold' ],
    data: () => ({
        infoBottom: 0,
    }),
    computed: {
        color() {
            if (this.recommend) return { value: "linear-gradient(to bottom right, yellow, lightgreen);" };
            return COLORS[this.tower.color];
        },
        content() {
            return this.tower.content.replace(/\n/g, '<br/>');
        },
        intest() {
            return Date.now() / 1000 - 172800 < this.tower.createTime;
        },
        tags() {
            return this.tower.tag.split("|");
        },
        recommend() {
            return this.tower.hot >= 3000;
        },
        hot() {
            return this.recommend ? this.tower.hot - 3000 : this.tower.hot;
        }
    },
    mounted() {
        if (this.useold) {
            this.adjustInfoBottom();
        }
    },
    methods: {
        adjustInfoBottom() {
            const authorStringHeight = Number(window.getComputedStyle(this.$refs.intro).height.slice(0, -2));
            this.infoBottom = String(authorStringHeight + 35) + 'px';
        },
        open() {
            window.open(this.tower.link, '_blank')
        }
    },
    watch: {
        useold(newval) {
            if (newval) {
                this.$nextTick(() => {
                    this.adjustInfoBottom();
                });
            }
        }
    },
    components: {
        Cover
    }
}
</script>

<style lang="less" scoped>
.tower-tab-old {
    color: black;
    text-align: left;

    background-color: rgba(252, 252, 252, 0.6);
    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);

    flex-shrink: 0;
    margin-bottom: 12px;
    margin-left: 1%;
    margin-right: 1%;
    // @media screen and (min-width: 1280px) {
    //     margin-left: 0.5%;
    //     margin-right: 0.5%;
    // }
    overflow: hidden;
    position: relative;
    height: 270px;
    width: 98%;
    @media screen and (min-width: 1280px) {
        width: 23%;
    }
    @media screen and (max-width: 1279px) and (min-width: 960px) {
        width: 31.333333%;
    }
    @media screen and (max-width: 959px) and (min-width: 600px) {
        width: 48%;
    }
    background-origin: border-box !important;
    & > * {
        margin: 3px 10px;
    }
    & > :last-child {
        margin-bottom: 8px;
    }
    .title {
        font-size: 14px;
    }
    .hot-label {
        color: red;
        font-weight: bold;
        margin-left: 8px;
        font-size: 12px;
    }
    .comment {
        position: absolute;
        right: 10px;
        font-size: 14px;
    }
    .tower-bottom {
        position: absolute;
        margin: 0;
        bottom: 0;
        height: 8px;
        width: 100%;
    }
    .tower-info {
        font-size: 12px;
        cursor: pointer;
        background-color: rgba(240, 240, 240, 0.6);
        position: absolute;
        top: 35px;
        left: 0;
        bottom: 26px;
        right: 0;
        overflow: auto;
        padding: 2px 5px;
    }
    .tower-intro {
        font-size: 13px;
        position: absolute;
        left: 0;
        bottom: 26px;
        font-weight: bold;
    }
    .tower-auths {
        position: absolute;
        left: 10px;
        bottom: 10px;
        font-size: 14px;
    }
    .tower-auth {
        color: #6E6E6E;
    }
    .tower-remaster {
        color: #A1A1A1;
    }
    .tower-tags {
        font-size: 14px;
        color: #828282;
        text-shadow: 0px 0px 1px rgba(128, 128, 128, 0.7);
        position: absolute;
        right: 10px;
        bottom: 10px;
        > span {
            margin-left: 4px;
        }
    }
}
.tower-tab {
    color: black;
    text-align: left;

    background-color: rgba(252, 252, 252, 0.6);
    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);

    flex-shrink: 0;
    margin-bottom: 12px;
    margin-left: 1%;
    margin-right: 1%;
    @media screen and (min-width: 1280px) {
        margin-left: 0.5%;
        margin-right: 0.5%;
    }
    @media screen and (max-width: 400px) {
        width: 100%;
        .tower-content {
            width: 240px;
        }
    }
    overflow: hidden;
    position: relative;

    width: 400px;
    height: 230px;
    max-width: 480px;
    .tower-main {
        height: 150px;
        width: 100%;
        display: flex;
    }
    .tower-bottom {
        width: 100%;
    }
    .tower-intro {
        padding: 1px 3px;
        font-size: 13px;
        font-weight: bold;
        overflow: hidden;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
    }
    .tower-info {
        font-size: 16px;
        width: 134px;
        background: rgba(0, 0, 0, 0.12);
        > div {
            padding: 2px 5px;
        }
        .tower-comment {
            bottom: 2px;
            right: 5px;
            position: absolute;
        }
        .hot-label {
            color: red;
            font-weight: bold;
        }
        .tower-auth {
            color: #2E2E2E;
        }
        .tower-remaster {
            color: #818181;
        }
    }
    .tower-tags {
        width: 100%;
        font-size: 14px;
        color: #828282;
        text-shadow: 0px 0px 1px rgba(128, 128, 128, 0.7);
        position: absolute;
        left: 0;
        bottom: 2px;
        display: flex;
        > span {
            margin-left: 4px;
        }
        .tower-comment {
            margin-left: auto;
            margin-right: 5px;
        }
    }
}
</style>

<style scoped>
@media screen and (max-width: 400px) {
    .tower-tab >>> .cover img {
        width: 240px;
    }
}
</style>